import pulldown from './pulldown'

export default function directive (Vue) {
  Vue.directive('pulldown', pulldown)
}



// WEBPACK FOOTER //
// ./src/directive/index.js